import React from 'react';
import { View } from "react-native";
import { SafeAreaView } from 'react-native-safe-area-context';
import ThemedStatusBar from "components/atoms/ThemedStatusBar";
import { colorList } from "utils/colors";
import HelperString from 'utils/helper-string'
import { themedSafeAreaTopStyles } from 'styles/components/atoms/ThemedSafeAreaTop'
import { layoutStyles } from 'styles/layout'

const ThemedSafeAreaTop = ({ top = true, pageBackground = colorList.PAGE.primary, children }) => {
	
	const topContainerStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		backgroundColor: pageBackground,
	}
	
	const topContentStyle = {
		flex: 1,
		backgroundColor: pageBackground
	}
	
	return (
		<View
			style={ layoutStyles.flexOne }>
				
			<View
				style={ topContainerStyle }>

				<View
					style={ topContentStyle }
				/>

				<View
					style={ themedSafeAreaTopStyles.pageDefault }
				/>
			</View>
		
			<ThemedStatusBar />
		
		 	{ top && (
				<SafeAreaView
					edges={[ 'top' ]}
					style={ themedSafeAreaTopStyles.topDefault }
					forceInset={{ top: 'always' }}
				/>
			)}

			<SafeAreaView
				edges={[ 'left', 'right' ]}
				style={ layoutStyles.flexOne }>
				
				{/* Safe are is for the rest of the page */}
				<View
					style={ layoutStyles.flexOne }>
					
					{ children }
				</View>
			</SafeAreaView>
		</View>
	)
}

export default ThemedSafeAreaTop
